import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
export const fadeUp = {
  hidden: {
    opacity: 0,
    y: 22
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function Pill({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-white/85 backdrop-blur" data-id="element-126">
      {children}
    </span>;
}
export function SectionLabel({
  children,
  dark = false
}: {
  children: React.ReactNode;
  dark?: boolean;
}) {
  return <div className={`mb-4 inline-flex items-center gap-2 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] ${dark ? 'border-white/15 bg-white/10 text-blue-100' : 'border-slate-200 bg-white text-slate-600 shadow-sm'}`} data-id="element-127">
      <span className="h-2 w-2 rounded-full bg-sky-400" data-id="element-128" />
      {children}
    </div>;
}
type CTAProps = {
  children: React.ReactNode;
  variant?: 'primary' | 'dark' | 'secondary';
  className?: string;
  to?: string;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
};
export function CTAButton({
  children,
  variant = 'primary',
  className = '',
  to,
  href,
  onClick,
  type = 'button'
}: CTAProps) {
  const base = 'group inline-flex items-center justify-center gap-2 rounded-2xl px-6 py-4 text-sm font-bold transition-all duration-300';
  const styles = variant === 'primary' ? 'bg-sky-400 text-slate-950 shadow-xl shadow-sky-500/20 hover:bg-sky-300' : variant === 'dark' ? 'bg-slate-950 text-white hover:bg-slate-800' : 'border border-white/20 bg-white/10 text-white backdrop-blur hover:bg-white/15';
  const content = <>
      {children}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-129" />
    </>;
  const cls = `${base} ${styles} ${className}`;
  if (to) {
    return <Link to={to} className={cls} data-id="element-130">
        {content}
      </Link>;
  }
  if (href) {
    return <a href={href} className={cls} data-id="element-131">
        {content}
      </a>;
  }
  return <button type={type} onClick={onClick} className={cls} data-id="element-132">
      {content}
    </button>;
}
export function PageHero({
  eyebrow,
  title,
  subtitle,
  children
}: {
  eyebrow: string;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}) {
  return <section className="relative overflow-hidden bg-slate-950 pt-32 pb-20 text-white" data-id="element-133">
      <div className="absolute left-1/2 top-0 h-[36rem] w-[36rem] -translate-x-1/2 rounded-full bg-sky-500/20 blur-3xl" data-id="element-134" />
      <div className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'linear-gradient(rgba(255,255,255,.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.35) 1px, transparent 1px)',
      backgroundSize: '42px 42px'
    }} data-id="element-135" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-136">
        <SectionLabel dark data-id="element-137">{eyebrow}</SectionLabel>
        <h1 className="max-w-4xl text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-138">
          {title}
        </h1>
        {subtitle && <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300" data-id="element-139">
            {subtitle}
          </p>}
        {children && <div className="mt-8" data-id="element-140">{children}</div>}
      </div>
    </section>;
}